import React, {useRef, useState, useEffect } from 'react';
import QRCode from 'qrcode.react';
import ReactDOM from "react-dom";
import { CustomBtn } from '../../button/button'
import { useDispatch, useSelector } from 'react-redux'
import { Padding } from '@mui/icons-material';
import getImage from '../../../assets/images/rawayat.png'
import rawayatAcademy from '../../../assets/images/rawayatAcademy.jpeg'
import getOsman from '../../../assets/images/osman.jpg'
import getNayab from '../../../assets/images/nayab2.png'


function NedaCard(props) {
    // console.log(props)
    const image = useSelector((state)=>state.Api.imageServer)
    const WebSrn = localStorage.getItem('WebSrn')
    const [qrCodeData, setQRCodeData] = useState('');
    const [catchUrl, setCatchUrl] = useState('')
    const generateQRCode = () => {
        const dataObj = {
            roleNo: String(props.info.RollNum),
            name: props.info.Name_P,
        };
        //console.log(JSON.stringify(dataObj))
        const getQrCodeData = `wasily.net,${props.info.RollNum},${props.info.Name}`;
        setQRCodeData(getQrCodeData);
    };

    function separateLanguages(text) {
        const arabicRange = /[\u0600-\u06FF]/;
        const englishChars = [];
        const arabicChars = [];
    
        for (let char of text) {
            if (arabicRange.test(char)) {
                arabicChars.push(char);
            } else {
                if (char !== ' ') { // Check if the character is not a space
                    englishChars.push(char);
                } else {
                    arabicChars.push(char); // Preserve space in Arabic text
                }
            }
        }
    
        const englishText = englishChars.join('');
        const arabicText = arabicChars.join('');
    
        return arabicText;
    }
    
    

    
    useEffect(() => {
        generateQRCode();
        let currentUrl = window.location.href; // Get the current URL
        const containsStudents = currentUrl.includes('Students');

        if (containsStudents) {
            // Remove "Private/View/Students" from the URL
            currentUrl = currentUrl.replace("Private/Veiw/Students", "");
        } else {
            // Remove "Private/View/Students" from the URL
            currentUrl = currentUrl.replace("Private/Veiw/Teacher", "");
        }
        setCatchUrl(currentUrl)
        //console.log(currentUrl);
    }, []);
 
    const NewWindowContent = () => {
        return(
            <div className={`card${WebSrn}`}>
            <div id="specificDiv" className="specificDivClass">
                <link rel="stylesheet" type="text/css" href={`${catchUrl}NeDefault.css`} />
                <div className="card">
                <div className="card-top-design">
                    <div className='gold-circle'> 
                        {
                            WebSrn == 14  ?      
                        <img src={getNayab} className="student-photo"  alt="logo" height={50} />
                            :WebSrn == 8  ?      
                        <img src={getImage} className="student-photo"  alt="logo" height={50} />
                            : WebSrn == 12 ?
                        <img src={getOsman} className="student-photo"  alt="logo" height={50} />
                        :WebSrn == 13 ?
                        <img src={rawayatAcademy} className="student-photo"  alt="logo" height={50} />
                        :
                        <img src={getOsman} className="student-photo"  alt="logo" height={50} />
                        }
                        {/* <img className="student-photo" src={`${image}${WebSrn}/Logo.png`} alt="Student Photo" /> */}
                    </div>
                    {WebSrn == 8  ? 
                        <p>روايت خصوصي ښوونځی </p>
                        : WebSrn == 12 ?
                        <p>مکتب خصوصی عثمان دانش</p>
                        : WebSrn == 13 ?
                        <p>روايت اکاډمــي</p>
                        : WebSrn == 7?
                        <p>لیسه عالی خصوصی نایاب شهر </p>
                        :
                        <></>
                    }
                </div>
                <div className={props.info.studentOrTeacher == 'student' ? 'teacherLine student' : 'teacherLine teacher'} ></div>
                <div className='qrCode' style={ props.info.studentOrTeacher != 'student' ? {padding: '12px 62px'} : null}>
                    {qrCodeData && (
                        <div>
                            <QRCode value={qrCodeData} size={props.info.studentOrTeacher == 'student'? 70 : 80} />
                        </div>
                    )}
                </div>
               <div className="card-body" style={ props.info.studentOrTeacher != 'student' ? {padding: '8px 6px'} : null}>
                    <div className='rollNumber'>{props.info.studentOrTeacher != 'student'? null : props.info.RollNum}</div>
                    <div className={props.info.studentOrTeacher == 'student' ? 'student-info' : 'teacher-info'} >
                        <h2>{` ${props.info.Name_P}`}</h2>
                        <h2>{`${props.info.Name}`}</h2>
                        {props.info.studentOrTeacher != 'student'? <h2 style={{fontSize:'22px', height:'20px'}}>{props.info.Job}</h2> : 
                        <>
                            <h2>{`${props.info.FName_P}`}</h2>
                            <h2>{separateLanguages(props.info.Class)}</h2>                        
                        </>
                        }
                    </div> 
                    {/* <div><table className='tradeMark'><tr><td>واصلي ټیکنالوژي 0703131865  </td></tr></table></div> */}
                </div>
                <div className={props.info.studentOrTeacher == 'student' ? 'card-footer student' : 'card-footer teacher teachFooter'} ></div>
                </div>
            </div>
            </div>
        )
    };

    const openNewWindow = () => {
        const newWindow = window.open('', '_blank', 'width=224,height=365');
        newWindow.document.body.innerHTML = '<div id="root"></div>'; // Create a root div in the new window
         // Create a link element for the CSS file
        const cssLink = newWindow.document.createElement('link');
        cssLink.rel = 'stylesheet';
        const url =window.location.href
        const catchUrl = url.replace("/Private/View/Students", "") 
        cssLink.href = `${catchUrl}/WasilyDefault.css`; // Replace 'path/to/your/css/file.css' with the actual path to your CSS file
        
        // Append the link element to the head of the new window's document
        newWindow.document.head.appendChild(cssLink);
        ReactDOM.render(<NewWindowContent />, newWindow.document.getElementById('root'));
    };

    return (
        <>
            <CustomBtn type="button" click={()=>openNewWindow()} data="Print Card  کارت چاپ کړئ" />
        </>
    );
}

export default NedaCard;
